import { BaseService } from "./BaseService";
import {
  GuestChannelPreference,
  UpsertGuestChannelPreferenceRequest,
} from "@/types/guest-channel-preference";

class GuestChannelPreferenceService extends BaseService {
  private path(guestId: string, hotelId: string): string {
    return `/guests/${guestId}/channel-preference/${hotelId}`;
  }

  fetch(guestId: string, hotelId: string): Promise<GuestChannelPreference> {
    return this.get<GuestChannelPreference>(
      this.path(guestId, hotelId),
      undefined,
      { disableToast: true },
    );
  }

  upsert(
    guestId: string,
    hotelId: string,
    payload: UpsertGuestChannelPreferenceRequest,
  ): Promise<GuestChannelPreference> {
    return this.put<GuestChannelPreference>(
      this.path(guestId, hotelId),
      payload,
    );
  }

  clear(guestId: string, hotelId: string): Promise<void> {
    return this.delete<void>(this.path(guestId, hotelId));
  }
}

export const guestChannelPreferenceService =
  new GuestChannelPreferenceService();
